import React from 'react'

import { Box, Grid } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'

import { DashboardChartPaper } from 'components'

import theme from 'theme'

const Skeletons = ({ count = 4 }) => (
  <Box display="flex" flexDirection="column" gridGap={24}>
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6}>
        <DashboardChartPaper title="Progresso" noMaxHeight>
          <Skeleton variant="rect" animation="wave" width="100%" height={230} />
        </DashboardChartPaper>
      </Grid>
      <Grid item xs={12} sm={6}>
        <DashboardChartPaper title="Conformidade" noMaxHeight>
          <Skeleton variant="rect" animation="wave" width="100%" height={230} />
        </DashboardChartPaper>
      </Grid>
    </Grid>

    <Grid container spacing={3}>
      <Grid item xs={12} sm={6}>
        <DashboardChartPaper title="Resolução dos Questionários" noMaxHeight>
          <Box display="flex" flexDirection="column" gridGap={theme.spacing(2)}>
            {[...Array(count)].map((_, i) => (
              <Skeleton
                key={'questionnaire-' + i}
                variant="rect"
                animation="wave"
                height={84}
              />
            ))}
          </Box>
        </DashboardChartPaper>
      </Grid>
      <Grid item xs={12} sm={6}>
        <DashboardChartPaper title="Evidências" noMaxHeight>
          <Box display="flex" flexDirection="column" gridGap={theme.spacing(2)}>
            {[...Array(count)].map((_, i) => (
              <Skeleton
                key={'evidence-' + i}
                variant="rect"
                animation="wave"
                height={84}
              />
            ))}
          </Box>
        </DashboardChartPaper>
      </Grid>
    </Grid>
  </Box>
)

export default Skeletons
